import { Box, useTheme } from '@chakra-ui/react';
import { useTableCellContext } from '../context';

const TableCellBadge = () => {
  const theme = useTheme();
  const { graphic02, mediumGrey } = theme.colors;

  const context = useTableCellContext();

  if (context.cellType === 'badge') {
    const {
      title,
      badgeBorderRadius,
      height,
      minHeight,
      margin,
      fontFamily,
      fontSize,
      color,
      lineHeight,
      textAlign,
      fontWeight,
      badgeColor,
      badgePadding,
      dataTestId
    } = context;

    return (
      <Box
        display='flex'
        alignItems='center'
        height={height || 'max-content'}
        minHeight={minHeight || 'max-content'}
        margin={margin || '6px'}
        padding={badgePadding || '10px'}
        borderRadius={badgeBorderRadius || '3px'}
        backgroundColor={badgeColor || graphic02}
        data-testid={dataTestId || 'cjtable-cell-badge-id'}
      >
        <Box
          color={color || mediumGrey}
          fontFamily={fontFamily || theme.fonts.regular}
          fontSize={fontSize || '12px'}
          fontWeight={fontWeight || 'normal'}
          lineHeight={lineHeight || '16px'}
          textAlign={textAlign || 'center'}
          data-testid='cjtable-cell-badge-text'
        >
          {title}
        </Box>
      </Box>
    );
  }
  return null;
};

export default TableCellBadge;
